import { createContext, useContext, useState } from "react";
import { apiLogin, apiRegister, apiUpdateProfile, apiGetProfile } from "../services/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("rizzglam_user")); } catch { return null; }
  });

  const persist = (u) => {
    localStorage.setItem("rizzglam_user", JSON.stringify(u));
    setUser(u);
  };

  const login = async (email, password) => {
    const res = await apiLogin({ email, password });
    if (res.error) throw new Error(res.error);
    localStorage.setItem("rizzglam_token", res.token);
    persist(res.user);
    return res.user;
  };

  const register = async (name, email, password, phone) => {
    const res = await apiRegister({ name, email, password, phone });
    if (res.error) throw new Error(res.error);
    localStorage.setItem("rizzglam_token", res.token);
    persist(res.user);
    return res.user;
  };

  const updateProfile = async (data) => {
    const res = await apiUpdateProfile(data);
    if (res.error) throw new Error(res.error);
    persist(res.user);
    return res.user;
  };
 
  const refreshProfile = async () => {
    const res = await apiGetProfile();
    if (!res.error) persist(res);
  };

  const logout = () => {
    localStorage.removeItem("rizzglam_token");
    localStorage.removeItem("rizzglam_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, updateProfile, refreshProfile }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
